import * as React from "react";
const SvgCheckmarkColorful = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<rect width={24} height={24} rx={12} fill="#A6CDDC" /><rect x={3} y={3} width={18} height={18} rx={9} fill="#7BB7CF" /><path d="M19.5 6L10.9063 16L7 11.4545" stroke="white" strokeWidth={2} strokeLinecap="square" /></svg>;
export default SvgCheckmarkColorful;